import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RoleService } from './shared/role.service';
import { UserService } from './shared/user.service';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UsersRoutingModule } from "./users-routing.module";
import { UserResolver } from "./shared/user-resolver.service";
import { UserDetailNavDirective } from "./user-detail/user-detail-nav.directive";
import { CoursesModule } from "../courses/courses.module";
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserCoursesComponent } from './user-courses/user-courses.component';
import { UserUpdateProfileButtonComponent } from "./user-update-profile-button/user-update-profile-button";

@NgModule({
  imports: [
    SharedModule,
    CoursesModule,
    UsersRoutingModule
  ],
  providers: [
    UserService,
    RoleService,
    UserResolver
  ],
  declarations: [
    UserDetailComponent,
    UserDetailNavDirective,
    UserProfileComponent,
    UserCoursesComponent,
    UserUpdateProfileButtonComponent
  ],
  exports: [
    UserUpdateProfileButtonComponent
  ]
})
export class UsersModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/users.module.ts